import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { EmergencyUnit } from '../../model/unit';
import { WebsocketService } from '../../service/websocket.service';
import { UnitState, UnitStore } from '../state/unit.store';
import { AkitaUnitHttpService } from './akita-unit-http.service';
import { UrlConfig } from '../../model/urlconfig';


@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class UnitService extends NgEntityService<UnitState> implements UrlConfig {

  constructor(
    protected store: UnitStore,
    private httpUnitService: AkitaUnitHttpService,
    private webSocketService: WebsocketService,
  ) {
    super(store);

    this.webSocketService.getDataStream('EmergencyUnit')
      .pipe(untilDestroyed(this))
      .subscribe((data: EmergencyUnit[]) => this.store.upsertMany(data));
  }
  updateEntitiesUrl(newUrl: string): void {
    this.httpUnitService.setEntitiesUrl(newUrl);
  }

  getAll() {
    this.httpUnitService.getAll().subscribe(units => this.store.add(units));
  }

  getById(id: ID) {
    this.httpUnitService.loadById(id).subscribe(units => this.store.add(units));
  }

}
